import { Category, ConfigurationFilterType, FilterField, ISelectableFilter } from '../api/reports.dao';
import { AttendeeRole } from '../api/attendees.dao';

export const REPORT_FIELD_CATEGORY_GROUPS = [{
        name: 'Meetings',
        category: Category.MEETING
    },
    {
        name: 'Attendees',
        category: Category.ATTENDEE
    },
    {
        name: 'Interactions',
        category: Category.INTERACTION
    },
    {
        name: 'Custom',
        category: Category.CUSTOM
    }
];

export const REGISTRATION_STATUS_FILTER: ISelectableFilter = {
    type: ConfigurationFilterType.CHECKBOX,
    field: FilterField.REGISTRATION_STATUS,
    label: 'Registration Status',
    items: [
        { value: 'Approved' },
        { value: 'Pending' },
        { value: 'Denied' }
    ]
};
export const EVENT_REGISTRATION_REPORT_AVAILABLE_FILTERS: ISelectableFilter[] = [
    {
        type: ConfigurationFilterType.DATE_TIME,
        field: FilterField.REGISTRATION_DATE_AND_TIME,
        label: 'Registration Date and Time',
        excludeFromSave: true
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_EMAIL_ADDRESS,
        label: 'Attendee Email Address',
        placeholder: 'Enter full or partial email address',
        defaultOperator: 'NOT_CONTAINS'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_FIRST_NAME,
        label: 'Attendee First Name',
        placeholder: 'Enter full or partial first name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_LAST_NAME,
        label: 'Attendee Last Name',
        placeholder: 'Enter full or partial last name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_ORGANIZATION_NAME,
        label: 'Attendee Organization Name',
        placeholder: 'Enter full or partial organization name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_PHONE_NUMBER,
        label: 'Attendee Phone Number',
        placeholder: 'Enter full or partial phone number'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_TITLE,
        label: 'Attendee Title',
        placeholder: 'Enter full or partial title'
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.ATTENDANCE_METHOD,
        label: 'Attendance Method',
        items: [{
            value: 'Virtual'
        }, {
            label: 'In Person',
            value: 'in_person'
        }, {
            value: 'Both'
        }]
    },
    REGISTRATION_STATUS_FILTER
];

export const ATTENDEE_INTERACTION_REPORT_AVAILABLE_FILTERS: ISelectableFilter[] = [
    {
        type: ConfigurationFilterType.MEETINGS,
        field: FilterField.MEETING_ID,
        label: 'Meetings',
        excludeFromSave: true,
        isRequired: true,
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_EMAIL_ADDRESS,
        label: 'Attendee Email Address',
        placeholder: 'Enter full or partial email address',
        defaultOperator: 'NOT_CONTAINS'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_ORGANIZATION_NAME,
        label: 'Attendee Organization Name',
        placeholder: 'Enter full or partial organization name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_FIRST_NAME,
        label: 'Attendee First Name',
        placeholder: 'Enter full or partial first name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_LAST_NAME,
        label: 'Attendee Last Name',
        placeholder: 'Enter full or partial last name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_PHONE_NUMBER,
        label: 'Attendee Phone Number',
        placeholder: 'Enter full or partial phone number'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_TITLE,
        label: 'Attendee Title',
        placeholder: 'Enter full or partial title'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TOPIC,
        label: 'Meeting Topic',
        placeholder: 'Enter full or partial meeting topic'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TRACK,
        label: 'Meeting Track',
        placeholder: 'Enter full or meeting track'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TYPE,
        label: 'Meeting Type',
        placeholder: 'Enter full or meeting type'
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.ATTENDANCE_METHOD,
        label: 'Attendance Method',
        items: [{
            value: 'Virtual'
        }, {
            label: 'In Person',
            value: 'in_person'
        }, {
            value: 'Both'
        }]
    },
    REGISTRATION_STATUS_FILTER
];

export const EVENT_INTERACTIONS_REPORT_AVAILABLE_FILTERS: ISelectableFilter[] = [
    {
        type: ConfigurationFilterType.DATE,
        field: FilterField.MEETING_DATE,
        label: 'Meeting Date',
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.ATTENDEE_MEETING_ROLE,
        label: 'Attendee Meeting Role',
        items: [{
            value: AttendeeRole.Presenter,
        }, {
            value: AttendeeRole.Participant
        }, {
            value: AttendeeRole.Host
        }, {
            value: AttendeeRole.Support
        }, {
            value: AttendeeRole.Registrant
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.MEETING_ACCESS,
        label: 'Meeting Access',
        items: [{
            value: 'Closed'
        }, {
            value: 'Open'
        }, {
            value: 'Plenary'
        }, {
            value: 'Bookable'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.MEETING_PROGRESS,
        label: 'Meeting Progress',
        items: [{
            value: 'Standby'
        }, {
            value: 'Ready'
        }, {
            value: 'Underway'
        }, {
            value: 'Ended'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.MEETING_STATUS,
        label: 'Meeting Status',
        items: [{
            value: 'Scheduled'
        }, {
            value: 'Cancelled'
        }, {
            value: 'Removed'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.ATTENDANCE_METHOD,
        label: 'Attendance Method',
        items: [{
            value: 'Virtual'
        }, {
            label: 'In Person',
            value: 'in_person'
        }, {
            value: 'Both'
        }]
    },
    REGISTRATION_STATUS_FILTER,
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.VERIFIED_ATTENDEE,
        label: 'Verified Attendee',
        items: [{
            value: 'True'
        }, {
            value: 'False'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.ATTENDEE_JOINING_METHOD,
        label: 'Attendee Joining Method',
        items: [{
            value: 'Audio'
        }, {
            value: 'Video'
        }, {
            label: 'In Person',
            value: 'in_person'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.JOINED_LIVE,
        label: 'Joined Live',
        items: [{
            value: 'Live'
        }, {
            label: 'On-Demand',
            value: 'On-Demand'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.LATE,
        label: 'Late',
        items: [{
            value: 'Late'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.MEETING_ATTENDEE_ISSUES,
        label: 'Meeting Attendee Issues',
        items: [{
            value: 'Bad Audio'
        }, {
            value: 'Bad Video'
        }, {
            value: 'Connection Dropped'
        }]
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.MEETING_ATTENDEE_STATUS,
        label: 'Meeting Attendee Status',
        items: [{
            value: 'Confirmed'
        }, {
            value: 'Cancelled'
        }, {
            value: 'Joined'
        }, {
            value: 'No Show'
        }, {
            label: 'Walk In',
            value: 'walk_in'
        }]
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_EMAIL_ADDRESS,
        label: 'Attendee Email Address',
        placeholder: 'Enter full or partial email address',
        defaultOperator: 'NOT_CONTAINS'
    },
    {
        type: ConfigurationFilterType.NUMBER,
        field: FilterField.INTERACTION_DURATION,
        label: 'Interaction Duration',
        additionalLabel: 'Minutes'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_ORGANIZATION_NAME,
        label: 'Attendee Organization Name',
        placeholder: 'Enter an Organization name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_FIRST_NAME,
        label: 'Attendee First Name',
        placeholder: 'Enter a first name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_LAST_NAME,
        label: 'Attendee Last Name',
        placeholder: 'Enter a last name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_PHONE_NUMBER,
        label: 'Attendee Phone Number',
        placeholder: 'Enter full or partial phone number'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_TITLE,
        label: 'Attendee Title',
        placeholder: 'Enter full or partial title'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TOPIC,
        label: 'Meeting Topic',
        placeholder: 'Enter full or partial meeting topic'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TRACK,
        label: 'Meeting Track',
        placeholder: 'Enter full or meeting track'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TYPE,
        label: 'Meeting Type',
        placeholder: 'Enter full or meeting type'
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.OPERATOR_SHARED_SCREEN,
        label: 'Operator Shared Screen',
        items: [
            { value: 'Yes' },
            { value: 'No' },
        ]
    }
];

export const REGISTRATION_BY_SESSION_REPORT_AVAILABLE_FILTERS: ISelectableFilter[] = [
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_EMAIL_ADDRESS,
        label: 'Attendee Email Address',
        placeholder: 'Enter full or partial email address',
        defaultOperator: 'NOT_CONTAINS'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_FIRST_NAME,
        label: 'Attendee First Name',
        placeholder: 'Enter full or partial first name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_LAST_NAME,
        label: 'Attendee Last Name',
        placeholder: 'Enter full or partial last name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_ORGANIZATION_NAME,
        label: 'Attendee Organization Name',
        placeholder: 'Enter full or partial organization name'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_PHONE_NUMBER,
        label: 'Attendee Phone Number',
        placeholder: 'Enter full or partial phone number'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.ATTENDEE_TITLE,
        label: 'Attendee Title',
        placeholder: 'Enter full or partial title'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TOPIC,
        label: 'Meeting Topic',
        placeholder: 'Enter full or partial meeting topic'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TRACK,
        label: 'Meeting Track',
        placeholder: 'Enter full or meeting track'
    },
    {
        type: ConfigurationFilterType.SEARCH,
        field: FilterField.MEETING_TYPE,
        label: 'Meeting Type',
        placeholder: 'Enter full or meeting type'
    },
    {
        type: ConfigurationFilterType.CHECKBOX,
        field: FilterField.ATTENDANCE_METHOD,
        label: 'Attendance Method',
        items: [{
            value: 'Virtual'
        }, {
            label: 'In Person',
            value: 'in_person'
        }, {
            value: 'Both'
        }]
    },
    REGISTRATION_STATUS_FILTER
];
